"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _es6Promise = _interopRequireDefault(require("es6-promise"));

var _datalist = _interopRequireDefault(require("../datalist"));

var _modal = _interopRequireDefault(require("../modal"));

var _configSelectList = _interopRequireDefault(require("./config-select-list"));

require("whatwg-fetch");

var _fetchUtils = _interopRequireDefault(require("../../fetchUtils"));

var _translate = _interopRequireDefault(require("../translate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

_es6Promise.default.polyfill();

var groupMap = {
  'Administrator': 'admins',
  'Kantonsverantwortliche': 'cantonResponsibleUser',
  'Projektverantwortliche': 'projectResponsibleUser'
};

/**
 *
 */
var SettingsUserManagement = /*#__PURE__*/function (_React$Component) {
  _inherits(SettingsUserManagement, _React$Component);

  function SettingsUserManagement(props) {
    var _this;

    _classCallCheck(this, SettingsUserManagement);

    _this = _possibleConstructorReturn(this, (SettingsUserManagement.__proto__ || Object.getPrototypeOf(SettingsUserManagement)).call(this, props));
    _this.state = {
      admins: [],
      projectResponsibleUser: [],
      cantonResponsibleUser: [],
      projects: [],
      cantons: [],
      editModes: {},
      isLoading: false,
      projectSelectOpen: false,
      cantonSelectOpen: false,
      currentPersonId: ''
    };
    _this.handleInputChange = _this.handleInputChange.bind(_assertThisInitialized(_this));
    _this.openEditCanton = _this.openEditCanton.bind(_assertThisInitialized(_this));
    _this.openEditProjects = _this.openEditProjects.bind(_assertThisInitialized(_this));
    _this.closeEditCanton = _this.closeEditCanton.bind(_assertThisInitialized(_this));
    _this.closeEditProjects = _this.closeEditProjects.bind(_assertThisInitialized(_this));
    _this.adminColumns = [{
      title: props.t('first name'),
      prop: 'first_name'
    }, {
      title: props.t('last name'),
      prop: 'last_name'
    }, {
      title: props.t('email'),
      prop: 'email'
    }];
    _this.projectResponsiblColumns = [{
      title: props.t('first name'),
      prop: 'first_name'
    }, {
      title: props.t('last name'),
      prop: 'last_name'
    }, {
      title: props.t('email'),
      prop: 'email'
    }, {
      title: props.t('project'),
      render: function render(val, row) {
        return /*#__PURE__*/_react.default.createElement("a", {
          className: "icon-link",
          href: "",
          "data-person-id": row.id,
          onClick: _this.openEditProjects
        }, /*#__PURE__*/_react.default.createElement("i", {
          className: "icon icon-edit"
        }));
      }
    }, {
      title: props.t('canton'),
      render: function render(val, row) {
        return /*#__PURE__*/_react.default.createElement("a", {
          className: "icon-link",
          href: "",
          "data-person-id": row.id,
          onClick: _this.openEditCanton
        }, /*#__PURE__*/_react.default.createElement("i", {
          className: "icon icon-edit"
        }));
      }
    }];
    _this.cantonResponsiblColumns = [{
      title: props.t('first name'),
      prop: 'first_name'
    }, {
      title: props.t('last name'),
      prop: 'last_name'
    }, {
      title: props.t('email'),
      prop: 'email'
    }, {
      title: props.t('project'),
      render: function render(val, row) {
        return /*#__PURE__*/_react.default.createElement("a", {
          className: "icon-link",
          href: "",
          "data-person-id": row.id,
          onClick: _this.openEditProjects
        }, /*#__PURE__*/_react.default.createElement("i", {
          className: "icon icon-edit"
        }));
      }
    }, {
      title: props.t('canton'),
      render: function render(val, row) {
        return /*#__PURE__*/_react.default.createElement("a", {
          className: "icon-link",
          href: "",
          "data-person-id": row.id,
          onClick: _this.openEditCanton
        }, /*#__PURE__*/_react.default.createElement("i", {
          className: "icon icon-edit"
        }));
      }
    }];
    _this.staticTexts = {
      search: props.t('search'),
      noData: props.t('no data'),
      loading: props.t('loading data'),
      all: props.t('all'),
      pageSize: props.t('results per page')
    };
    return _this;
  }
  /**
   *
   */


  _createClass(SettingsUserManagement, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.setState({
        isLoading: true
      });
      fetch("/api/".concat(this.props.i18n.language, "/backendusers"), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (persons) {
        var map = {
          admins: [],
          projectResponsibleUser: [],
          cantonResponsibleUser: []
        };
        persons.forEach(function (person) {
          map[groupMap[person.group.name]].push(person);
        });

        _this2.setState(function (prev) {
          prev.admins = map.admins;
          prev.projectResponsibleUser = map.projectResponsibleUser;
          prev.cantonResponsibleUser = map.cantonResponsibleUser;
          prev.isLoading = false;
          return prev;
        });
      }).catch(function (err) {
        void 0;
      });
      fetch("/api/".concat(this.props.i18n.language, "/projects"), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (projects) {
        _this2.setState(function (prev) {
          prev.projects = projects;
          return prev;
        });
      }).catch(function (err) {
        void 0;
      });
      fetch("/api/".concat(this.props.i18n.language, "/cantons"), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (cantons) {
        _this2.setState(function (prev) {
          prev.cantons = cantons;
          return prev;
        });
      }).catch(function (err) {
        void 0;
      });
    }
    /**
     *
     * @returns {*}
     */

  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "comp-settings-user-management grid-x"
      }, this.state.projectSelectOpen && /*#__PURE__*/_react.default.createElement(_modal.default, {
        id: "projects-select",
        isOpen: this.state.projectSelectOpen,
        closeHandler: this.closeEditProjects,
        escClose: true,
        backgroundClickClose: true
      }, /*#__PURE__*/_react.default.createElement(_configSelectList.default, {
        items: this.state.projects,
        currentPersonId: this.state.currentPersonId,
        users: this.state.projectResponsibleUser.concat(this.state.cantonResponsibleUser),
        onChange: this.handleInputChange('project'),
        type: 'projects'
      }), /*#__PURE__*/_react.default.createElement("button", {
        className: "btn",
        onClick: this.closeEditProjects
      }, t('close'))), this.state.cantonSelectOpen && /*#__PURE__*/_react.default.createElement(_modal.default, {
        id: "projects-select-canton",
        isOpen: this.state.cantonSelectOpen,
        closeHandler: this.closeEditCanton,
        escClose: true,
        backgroundClickClose: true
      }, /*#__PURE__*/_react.default.createElement(_configSelectList.default, {
        items: this.state.cantons,
        currentPersonId: this.state.currentPersonId,
        users: this.state.projectResponsibleUser.concat(this.state.cantonResponsibleUser),
        onChange: this.handleInputChange('canton'),
        type: 'cantons'
      }), /*#__PURE__*/_react.default.createElement("button", {
        className: "btn",
        onClick: this.closeEditCanton
      }, t('close'))), /*#__PURE__*/_react.default.createElement("div", {
        className: "cell"
      }, /*#__PURE__*/_react.default.createElement("h2", null, t('User Management')), /*#__PURE__*/_react.default.createElement("h3", null, t('Admins')), /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 large-9 xlarge-8"
      }, /*#__PURE__*/_react.default.createElement(_datalist.default, {
        keys: ['id'],
        withControls: true,
        enableSort: false,
        columns: this.adminColumns,
        initialData: this.state.admins,
        staticTexts: this.staticTexts,
        initialPageLength: 20
      }))), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement("h3", null, t('Project responsibles')), /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 large-9 xlarge-8"
      }, /*#__PURE__*/_react.default.createElement(_datalist.default, {
        keys: ['id'],
        withControls: true,
        enableSort: false,
        columns: this.projectResponsiblColumns,
        initialData: this.state.projectResponsibleUser,
        staticTexts: this.staticTexts,
        initialPageLength: 20
      }))), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement("h3", null, t('Canton responsibles')), /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 large-9 xlarge-8"
      }, /*#__PURE__*/_react.default.createElement(_datalist.default, {
        keys: ['id'],
        enableSort: false,
        columns: this.cantonResponsiblColumns,
        initialData: this.state.cantonResponsibleUser,
        staticTexts: this.staticTexts,
        initialPageLength: 20
      })))));
    }
    /**
     *
     * @param target
     * @returns {Function}
     */

  }, {
    key: "handleInputChange",
    value: function handleInputChange(target) {
      var _this3 = this;

      return function (userId, targetId, checked) {
        var method = checked ? 'DELETE' : 'POST';
        fetch("/api/".concat(_this3.props.i18n.language, "/backendusers/").concat(userId, "/").concat(target, "/").concat(targetId), {
          method: method,
          credentials: 'include'
        }).then(_fetchUtils.default.checkStatus).then(function (response) {
          var map = _this3.state[groupMap[response.group.name]];
          map = map.map(function (person) {
            return person.id === response.id ? response : person;
          });

          _this3.setState(function (prev) {
            prev[groupMap[response.group.name]] = map;
            return prev;
          });
        }).catch(function (err) {
          void 0;
        });
      };
    }
    /**
     *
     * @param e
     */

  }, {
    key: "openEditProjects",
    value: function openEditProjects(e) {
      var currentPersonId = e.currentTarget.getAttribute('data-person-id');
      this.setState({
        projectSelectOpen: true,
        currentPersonId: currentPersonId
      });
      e.preventDefault();
    }
    /**
     *
     */

  }, {
    key: "closeEditProjects",
    value: function closeEditProjects() {
      this.setState({
        projectSelectOpen: false,
        currentPersonId: ''
      });
    }
    /**
     *
     * @param e
     */

  }, {
    key: "openEditCanton",
    value: function openEditCanton(e) {
      var currentPersonId = e.currentTarget.getAttribute('data-person-id');
      this.setState({
        cantonSelectOpen: true,
        currentPersonId: currentPersonId
      });
      e.preventDefault();
    }
    /**
     *
     */

  }, {
    key: "closeEditCanton",
    value: function closeEditCanton() {
      this.setState({
        cantonSelectOpen: false,
        currentPersonId: ''
      });
    }
  }]);

  return SettingsUserManagement;
}(_react.default.Component);

SettingsUserManagement.propTypes = {
  t: _propTypes.default.func.isRequired,
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string
  })
};

var _default = (0, _translate.default)(SettingsUserManagement);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/settings-user-management/index.js
// module id = 725
// module chunks = 0